import { render } from "./RightSidebar.vue?vue&type=template&id=08b5fc59"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__